__webpack_require__.p = "/wp-content/themes/wmx/strapi/build/";